import globalConfig from '@utiles/globalConfig';
export const ERROR_TYPE = {
  PAY_TYPE_LIST_EMPTY: 'pay_type_list_empty', // 渠道列表为空
  PRODUCT_LIST_EMPTY: 'product_list_empty', // 商品列表返回为空
  AUTO_MATCH_PRODUCT_FAIL: 'auto_match_product_fail', // 游戏内打开没有自动匹配上商品
  MATCH_CART_PRODUCT_LEVEL_FAIL: 'match_cart_product_level_fail', // 购物车商品价格档位不匹配
  PAGE_JUMP_404: 'page_jump_404', // 404页面
  SWITCH_PAY_PRODUCT_MATCH_FAIL: 'switch_pay_product_match_fail', // 切支付商品匹配不上
  POPUP_MATCH_CART_PRODUCT_LEVEL_FAIL: 'popup_match_cart_product_level_fail', // 弹窗购物车商品价格档位不匹配

  CHECKOUT_INIT_ERROR: 'checkout_init_error', // 初始化checkout错误
  CHECKOUT_INIT_PARAMS_ERROR: 'checkout_init_params_error', // 初始化checkout参数错误
  CHECKOUT_NO_PAY_TYPE: 'checkout_no_pay_type', // 不支持的checkout渠道
  CHECKOUT_PAY_TYPE_NOT_AVAILABLE: 'checkout_pay_type_not_available', // checkout paytype不可用
  CHECKOUT_SUBMIT_ERROR: 'checkout_submit_error', // checkout提交错误
};

const getPageVersion = () => {
  let version = 'v0';
  if (window.isOfficialStore) {
    version = 'v1';
  } else if (window.isOfficialWebStore) {
    version = 'v2';
  } else if (window.isOfficialTopup) {
    version = 'v3';
  } else if (window.isOfficialTopupNew) {
    version = 'v3.5';
  }
  return version;
};

const getPagePointName = () => {
  const pagePointNameMap = {
    'v0': 'sdkstoreDataLayer',
    'v1': 'webstorev1DataLayer',
    'v2': 'webstorev2DataLayer',
    'v3': 'webstorev3DataLayer',
    'v3.5': 'webstorev35DataLayer'
  }
  return pagePointNameMap[getPageVersion()];
};

export const errorReport = (errorType, extraInfo = {}) => {
  try {
    window?.[getPagePointName()]?.push({
      eventName: errorType,
      eventType: 'customer_error_pay',
      eventValue: {
        loginAccount: globalConfig.getHrefParamUndecode('loginAccount') || '',
        uid: globalConfig.getHrefParamUndecode('userId') || '',
        roleId: globalConfig.getHrefParamUndecode('roleId') || '',
        roleName: globalConfig.getHrefParamUndecode('roleName') || '',
        serverId: globalConfig.getHrefParamUndecode('serverId') || '',
        language: globalConfig.getHrefParamUndecode('language') || '',
        ...extraInfo
      },
      gameId: globalConfig.getHrefParamUndecode('gameId') || '',
    });

  } catch (e) {
    console.error(e);
  }
};

export const errorReport404 = () => {
  try {
    window?.[getPagePointName()]?.push({
      eventName: ERROR_TYPE.PAGE_JUMP_404,
      eventType: 'customer_error_pay',
      eventValue: {
        loginAccount: globalConfig.getHrefParamUndecode('loginAccount') || '',
        uid: globalConfig.getHrefParamUndecode('userId') || '',
        roleId: globalConfig.getHrefParamUndecode('roleId') || '',
        roleName: globalConfig.getHrefParamUndecode('roleName') || '',
        serverId: globalConfig.getHrefParamUndecode('serverId') || '',
        language: globalConfig.getHrefParamUndecode('language') || '',
        version: getPageVersion(),
        packageName: globalConfig.getHrefParamUndecode('packageName') || '',
        domain: window.location.hostname,
        packageVersion: globalConfig.getHrefParamUndecode('packageVersion') || ''
      },
      gameId: globalConfig.getHrefParamUndecode('gameId') || '',
    });
  } catch (e) {
    console.error(e);
  }
};
